import { render, staticRenderFns } from "./transcriptsList.component.vue?vue&type=template&id=8b1bd226&scoped=true&"
import script from "./transcriptsList.component.vue?vue&type=script&lang=js&"
export * from "./transcriptsList.component.vue?vue&type=script&lang=js&"
import style0 from "./transcriptsList.component.vue?vue&type=style&index=0&id=8b1bd226&scoped=true&lang=scss&"
import style1 from "./transcriptsList.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1bd226",
  null
  
)

export default component.exports